<template>
  <div class="flex-column h-100">
    <div class="entity-info-header">
      <b-row>
        <b-col cols="2">
          <b-form-checkbox size="xl" class="select-all darkbg" v-model="selectAll" v-on:change="select($event)"></b-form-checkbox>
        </b-col>
        <b-col cols="2">
          <core class="item-info img-icon core"  v-b-tooltip.hover title="Core"></core> 
        </b-col>
        <b-col cols="2">
          <plugins class="item-info img-icon plugins"  v-b-tooltip.hover title="Plugins"></plugins> 
        </b-col>
        <b-col cols="2" >
          <themes class="item-info img-icon themes"  v-b-tooltip.hover title="Themes"></themes> 
        </b-col>
        <b-col cols="2">
          <translations class="item-info img-icon translations"  v-b-tooltip.hover title="Translations"></translations> 
        </b-col>
      </b-row>
      <div class="text-right position-relative">
        <b-input class="mb-2 mr-sm-2 mb-sm-0 search-input" v-model="search" id="search_text" type="text" placeholder="Search" />
        <div class="search-icon-container">
          <magnifier-icon class="icon-default search-icon"></magnifier-icon>
        </div>
      </div>
    </div>
    <div class="custom-tab-body-cont h-100 websiteview" id="websiteviewcontainer" @scroll="scroll()">
	   	<div v-for="(entity, index) in entities"  :key="index" class="item-row-web">
        <div v-b-toggle="index" class="active" @click="showSpecificEntity(index, specificEntity[index])">
            <b-row>
              <b-col>
                <b-row class="item-name-cont">
                  <b-form-checkbox size="lg" class="master-checkbox darkbg" :checked="shouldSelected(entity)" v-on:change="toggleGroup(entity, $event)">
                  </b-form-checkbox>
                  <b-col cols="1" :aria-controls="index" @click="onShow" class="item-collapse-col">
                    <span class="item-count" v-if="entity.core">{{entity.core.length}}</span>
                    <span class="item-count" v-else>0</span>
                  </b-col>
                  <b-col cols="1" :aria-controls="index" @click="onShow" class="item-collapse-col">
                    <span class="item-count" v-if="entity.plugins">{{entity.plugins.length}}</span>
                    <span class="item-count" v-else>0</span>
                  </b-col>
                  <b-col cols="1" :aria-controls="index" @click="onShow" class="item-collapse-col">
                    <span class="item-count" v-if="entity.themes">{{entity.themes.length}}</span>
                    <span class="item-count" v-else>0</span>
                  </b-col>
                  <b-col cols="1" :aria-controls="index" @click="onShow" class="item-collapse-col">
                    <span class="item-count" v-if="entity.translations">{{entity.translations.length}}</span>
                    <span class="item-count" v-else>0</span>
                  </b-col>
                  <b-col :aria-controls="index" @click="onShow" class="item-collapse-col-name">
                    <span class="item-name">{{index}}</span>
                  </b-col>
                  <b-col :aria-controls="index" @click="onShow" v-if="showUpdateStaging" class="item-collapse-col-name ">
                    <span class="item-name float-right"><update-staging :entity="entity" :updateType='`group`'  :siteName="index"></update-staging></span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
        </div>
      <b-collapse :id="index" class="entity-show"  role="tabpanel" v-if="specificEntity[index]">
          <b-row v-for="(siteItem, key) in entity" :key="key" class="child-item-row">
            <b-col cols="2" class="text-center"><label class="tittle"><component class="img-icon mt-0.5 " :class="key" v-bind:is="key"></component><span class="position-absolute">{{key}}&nbsp;({{siteItem.length}})</span></label></b-col>
            <b-col class="mb-3">
              <b-row v-if="key!=='core' && siteItem.length>1">
                <b-col class="specific-selection">
                  <div>
                    <span class="select-label">Select: </span>
                    <span><b-link @click="toggleSites(entity,siteItem, true)" variant="link">All</b-link> </span>
                    <span><b-link @click="toggleSitesInvert(entity,siteItem, true)" variant="link">Invert</b-link> </span>
                    <span><b-link @click="toggleSites(entity,siteItem, false)" variant="link">None</b-link> </span>
                  </div>
                </b-col>
              </b-row>

              <b-row v-for="(site, id) in siteItem" :key="id">
                      
                <b-col class="subitem-col">
                  <b-form-checkbox class="darkbg" :checked="site.selected" v-on:change="toggleSite(entity,site, $event)">
                    <div>
                      <span class="child-item-name" v-html="site.name"></span>
                      <span class="version-log">
                        <span class="version-from">{{site.old_version}}</span>
                        <span class="version-arrow" v-if="site.new_version">
                          <right-arrow-icon class="icon-default right-arrow"></right-arrow-icon>
                        </span>
                        <span class="version-to" v-if="site.change_log"><a :href="site.change_log" target="_blank">{{site.new_version}}</a></span>
                        <span class="version-to" v-else>{{site.new_version}}</span>
                        <span class="item-name text-center" v-if="site.vulnerability"><a class="view-vuls" :href="site.vulUrl" target="_blank">View vulnerability</a></span>
                       <span class="item-name float-right" v-if="showUpdateStaging"><update-staging :entity="site" :updateType='`single`'  :siteName="index"></update-staging></span>
                      </span>
                      
                    </div>
                  </b-form-checkbox>
                </b-col>
                
              </b-row>
            </b-col>
          </b-row>
        </b-collapse>
		</div>

    <empty-placeholder v-if="entities.length===0" v-bind="placeholderProps"></empty-placeholder>
    </div>
    <div class="custom-tab-body-footer">
      <b-row>
        <b-col class="text-right">
          <label class="selected-label">{{selectedUpdatesCount}} selected</label>
          <span>
            <b-button v-if="!viewIgnore || viewIgnore == 'vulnerability'" variant="outline-secondary" @click="ignore()" :disabled="!selectedUpdatesCount">
              Ignore
              <spinner size="small" class="greybg" v-if="buttonLoaders.ignore"></spinner>
            </b-button>
            <b-button v-else variant="outline-secondary" @click="unIgnore()" :disabled="!selectedUpdatesCount">
              Un-Ignore
              <spinner size="small" class="greybg" v-if="buttonLoaders.unIgnore"></spinner>
            </b-button>
            <b-button variant="primary" class="ml-6" @click="update()" :disabled="!selectedUpdatesCount">
              Update
              <spinner size="small" v-if="buttonLoaders.update"></spinner>
            </b-button>
          </span>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import updateItem from './UpdateItem';
import EmptyPlaceholder from '../Common/EmptyPlaceholder';
import Plugins from '../../assets/plugins.svg';
import MagnifierIcon from '../../assets/lens.svg';
import Themes from '../../assets/themes.svg';
import Core from '../../assets/wordpress.svg';
import Translations from '../../assets/translation.svg';
import RightArrowIcon from "../../assets/rightarrow.svg";

export default {
  name: 'entityupdater',
  props: ['entities', 'type', 'buttonLoaders', 'viewIgnore','showUpdateStaging', 'selectedUpdatesCount'],
  components: {
    updateItem,
    Plugins,
    Core,
    Translations,
    Themes,
    MagnifierIcon,
    EmptyPlaceholder,
    RightArrowIcon,
    UpdateStaging :() =>
      import(/* webpackChunkName: 'Staging/index' */ '../addons/Staging/index').then(
        ({ UpdateStaging }) => UpdateStaging
      ),  
  },
  data() {
    return {
      selectAll: false,
      currentTabIndex: 0,
      showUpdatePopup: false,
      placeholderProps: {
        text: () => {
          return `Looks like there are no ${this.type} updates.`;
        },
        type: 'positive'
      },
      search: "",
      show: false,
      specificEntity : [],
      paginate: 0
    };
  },
  mounted(){
    let elmnt = document.getElementById("websiteviewcontainer");
    let height = elmnt.offsetHeight;
    let total = height/40;
    this.paginate = parseInt(total)+5;
    this.$emit('paginatevalue', this.paginate);
    this.$emit('update:searchtext', '');
    this.select(false);
  },
  watch:{
    search(updatedValue) {
      this.$emit('update:searchtext', updatedValue);
      // 
    },
    viewIgnore(){
      this.selectAll = false;
    }
  },
  methods: {
    select(selectedValue) {
      this.$emit('selectAll', {
        type: "websites",
        value: selectedValue
      });
    },
    getSelectedUpdates(updates) {
      let sites = [];
      _.each(updates, update => {
        let selectedSiteCore = _.filter(update.core, { selected: true });
        sites = _.concat(sites, selectedSiteCore);
        let selectedSitePlugins = _.filter(update.plugins, { selected: true });
        sites = _.concat(sites, selectedSitePlugins);
        let selectedSiteThemes = _.filter(update.themes, { selected: true });
        sites = _.concat(sites, selectedSiteThemes);
        let selectedSiteTranslations = _.filter(update.translations, { selected: true });
        sites = _.concat(sites, selectedSiteTranslations);
      });
      return sites;
    },
    toggleSite( group, site, isSelected ) {
      this.$store.commit({
        type: 'SELECT_SITE_UPDATE',
        site: site,
        value: isSelected
      });
    },
    toggleSites( group, sites, isSelected ) {
      _.each(sites, site => {
        this.$store.commit({
          type: 'SELECT_SITE_UPDATE',
          site: site,
          value: isSelected
        });
      })
    },
    toggleSitesInvert( group, sites, isSelected ) {
      _.each(sites, site => {
        this.$store.commit({
          type: 'SELECT_SITE_UPDATE',
          site: site,
          value: !site.selected
        });
      })
    },
    update() {
      this.$emit('update', {
        value: 'website'
      });
    },
    ignore() {
      this.$emit('ignore', {
        value: 'website'
      });
    },
    unIgnore() {
      this.$emit('unIgnore', {
        value: 'website'
      });
    },
    onShow() {
      
      this.show = !this.show;
    },
    onHide() {
      this.show = false;
    },
    shouldSelected(entity) {
      var selectedPlugins = 0;
      var plugins = 0;
      var selectedThemes = 0;
      var themes = 0;
      var selectedCore = 0;
      var core = 0;
      var selectedTranslations = 0;
      var translations = 0;
      if (entity.plugins && entity.plugins.length >0) {
        selectedPlugins = _.filter(entity.plugins, { selected: true });
        plugins = entity.plugins.length;
      }
      if (entity.themes && entity.themes.length >0) {
        selectedThemes = _.filter(entity.themes, { selected: true });
        themes = entity.themes.length;
      }
      if (entity.core && entity.core.length >0) {
        selectedCore = _.filter(entity.core, { selected: true });
        core = entity.core.length;
      }
      if (entity.translations && entity.translations.length >0) {
        selectedTranslations = _.filter(entity.translations, { selected: true });
        translations = entity.translations.length;
      }
      if (((plugins == 0) || plugins === selectedPlugins.length) && ((themes == 0) || themes === selectedThemes.length) && ((core == 0) || core === selectedCore.length) && ((translations == 0) || translations === selectedTranslations.length)) {
        return true;
      }
      return false;
    },
    toggleGroup(entity, value) {
      _.each(entity, group => {
        _.each(group, site => {
          this.$store.commit({
            type: 'SELECT_GROUP_UPDATES',
            sites: [site],
            value: value
          });
        })
      });
    },
    showSpecificEntity(index, existingEntity){
      if (typeof existingEntity != 'undefined' && existingEntity != null && existingEntity == true) {
        this.specificEntity[index] = false;
        this.$root.$emit('bv::toggle::collapse', index);
      }else{
        this.specificEntity[index] = true;
      }
      Vue.nextTick().then(() => {
        this.$forceUpdate();
      });
    },
    scroll () {
      let elmnt = document.getElementById("websiteviewcontainer");
      let y = elmnt.scrollTop;
      let sh = elmnt.scrollHeight;
      let height = elmnt.offsetHeight;
      if ((sh-y) <= height) {
        this.$emit('action', this.paginate);
      }
    },
  }
};
</script>

<style scoped>
.item-row {
  cursor: pointer;
}
.custom-control {
  width: auto;
}
.master-checkbox {
  margin-top: 7px;
  margin-left: 16px;
}
</style>
